<template>
	<fieldset
		v-if="name"
		class="itv-input-simple-select"
		v-click-outside="onClickOutside"
	>
		<input class="visually-hidden" type="text" :name="name" v-model="value" />
		<div v-if="label" class="itv-input-simple-select__label">
			{{ label }}
		</div>
		<div class="itv-input-simple-select__trigger-wrap">
			<button
				class="itv-input-simple-select__trigger"
				:class="{ active: listVisible, hasValue: value }"
				@click.prevent="listVisible = !listVisible"
			>
				<span class="itv-input-simple-select__output">
					{{ outputText }}
				</span>
			</button>
			<div v-if="value" class="itv-input-simple-select__clear">
				<btn-clear @click-event="clearField" />
			</div>
		</div>
		<template v-if="isMobile && listFormated.length > 0">
			<Transition>
				<modal-default
					v-if="listVisible"
					class="itv-input-simple-select__mobile"
					@hide-modal="listVisible = false"
				>
					<template v-if="placeholder" #header>
						{{ placeholder }}
					</template>
					<template #content>
						<ul class="itv-input-simple-select__list">
							<li
								v-for="(item, i) in listFormated"
								:key="i"
								class="itv-input-simple-select__item-wrap"
							>
								<button
									v-if="item.text"
									class="itv-input-simple-select__item"
									:class="{ active: item.active }"
									@click.prevent="chooseItem(item, i)"
								>
									{{ item.text }}
								</button>
							</li>
						</ul>
					</template>
				</modal-default>
			</Transition>
		</template>

		<div
			v-if="!isMobile && listVisible"
			class="itv-input-simple-select__desktop"
		>
			<ul v-if="listFormated.length > 0" class="itv-input-simple-select__list">
				<li
					v-for="(item, i) in listFormated"
					:key="i"
					class="itv-input-simple-select__item-wrap"
				>
					<button
						v-if="item.text"
						class="itv-input-simple-select__item"
						:class="{ active: item.active }"
						@click.prevent="chooseItem(item, i)"
					>
						{{ item.text }}
					</button>
				</li>
			</ul>
		</div>
	</fieldset>
</template>

<script>
import vClickOutside from 'click-outside-vue3'

import BtnClear from './BtnClear'
import ModalDefault from './ModalDefault'

export default {
	name: 'SimpleSelect',
	directives: {
		clickOutside: vClickOutside.directive,
	},
	components: {
		BtnClear,
		ModalDefault,
	},
	props: {
		id: {
			type: String,
			default: 'SELECT',
		},
		list: {
			type: Array,
			default: [],
		},
		placeholder: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			activeIndex: null,
			listVisible: false,
			outputText: '',
			value: '',
			listFormated: [],
		}
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
	},
	watch: {
		list: {
			handler(newVal, oldVal) {
				this.createList(newVal)

				const currentVal = newVal.filter(el => el.value === this.value)[0]
				if (this.value && !currentVal) {
					this.clearField()
				}
			},
			deep: true,
		},
	},
	methods: {
		chooseItem(item, index) {
			this.listFormated.forEach(el => {
				el.active = false
			})
			this.listVisible = false
			this.value = item.value
			this.outputText = item.text
			this.activeIndex = index
			this.$emit('changeValue', this.value, this.id)
		},

		onClickOutside() {
			if (this.listVisible) {
				this.listVisible = false
			}
		},

		clearField() {
			this.activeIndex = null
			this.value = ''
			this.outputText = this.placeholder

			this.$emit('changeValue', this.value, this.id)
		},

		createList(list) {
			if (list.length > 0) {
				this.listFormated = list.map((el, i) => {
					if (this.activeIndex === i) {
						return { text: el.title, value: el.value, active: true }
					}

					return { text: el.title, value: el.value, active: false }
				})
			}
		},
	},

	created() {
		const historyParam = new URLSearchParams(window.location.search).get(
			this.id
		)

		if (this.list.length > 0) {
			this.listFormated = this.list.map(el => {
				if (el.value === historyParam) {
					return { text: el.title, value: el.value, active: true }
				}

				// костыль обратной совместимости
				if (
					new URLSearchParams(window.location.search).get('onlyIT') &&
					new URLSearchParams(window.location.search).get('onlyIT') === 'Y' &&
					el.value === 'it'
				) {
					return { text: el.title, value: el.value, active: true }
				}
				// end костыль обратной совместимости

				return { text: el.title, value: el.value, active: false }
			})
		}

		const activeEl = this.listFormated.filter(el => el.active)[0]
		if (activeEl) {
			this.outputText = activeEl.text
			this.value = activeEl.value
			return
		}

		if (this.placeholder) {
			this.outputText = this.placeholder
		}
	},
}
</script>
